import { useDispatch, useSelector } from "react-redux";
import CoachMenuLayout from "../../../layouts/CoachMenuLayout";
import { useEffect } from "react";
import { fetchCoachingDashboard } from "../../../redux/features/coach/actions/coachAction";
import Loader from "../../../components/loader";

const CoachCoaching = () => {
  const dispatch = useDispatch();
  const { isLoading2, coachingDashboardData } = useSelector(
    (state) => state.coach.coach
  );

  useEffect(() => {
    dispatch(fetchCoachingDashboard());
  }, []);

  if (isLoading2) {
    return <Loader />;
  }
  return (
    <CoachMenuLayout>
      <div class="ct_px_40 mt-4">
        <div class="mb-4">
          <div class="d-flex align-items-center gap-3 justify-content-between ct_flex_col_991 mt-5 mb-4">
            <div>
              <h4 class="mb-0 ct_fs_20 ct_fw_600 mb-2">My Coaching Circle</h4>
              <p class="ct_grey_text mb-0">
                Track, manage, and grow your client connections
              </p>
            </div>

            <div class="d-flex align-items-center gap-3 justify-content-end ct_flex_col_575 ct_w_100_575">
              <div class="position-relative ct_w_100_575">
                <input
                  type="text"
                  class="form-control ct_input ct_h_35 ps-5"
                  placeholder="Search by Name"
                />
                <i class="fa-solid fa-search ct_input_icon_left"></i>
              </div>
            </div>
          </div>

          <div class="row mt-5">
            <div class="col-lg-3 mb-4 mb-lg-0">
              <div class="ct_discovery_call_card">
                <div>
                  <img src="../assets/img/call_icon_2.png" alt="" />
                </div>
                <h4 class="ct_fs_24 text-white mt-3 mb-3">12 bookings</h4>
                <div>
                  <p class="ct_fs_16 text-center mb-1">Discovery Call</p>
                  <p class="ct_fs_12 ct_darksky_blue_text text-center">
                    Connect and explore needs.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-9 mb-4 mb-lg-0">
              <div class="row">
                <div class="col-lg-4 col-md-6 mb-4">
                  <div class="ct_outline_bg h-100 ct_p_10">
                    <div class="d-flex align-items-start justify-content-between gap-2">
                      <div>
                        <p class="ct_fs_16 ct_orange_text mb-2">
                          Clarity Boost
                        </p>
                        <h4 class="ct_fs_24">
                          {coachingDashboardData?.clarity_count || 0}
                        </h4>
                      </div>
                      <img src="../assets/img/dash_icon_2.png" alt="" />
                    </div>
                    <ul class="d-flex align-items-center gap-2 mt-1">
                      <li class="ct_fs_12 ct_sky_blue_text">
                        38%
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_1696_32145)">
                            <path
                              d="M5.73231 8.00261L15.8359 13.8359"
                              stroke="#8ECAE6"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M9.74891 15.7105L16.1237 14.0024L14.4156 7.6276"
                              stroke="#8ECAE6"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1696_32145">
                              <rect
                                width="16"
                                height="16"
                                fill="white"
                                transform="translate(21.8555 8.07031) rotate(120)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </li>
                      <li class="ct_text_op_2">|</li>
                      <li class="ct_grey_text ct_fs_12">
                        your hosted events score
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 mb-4">
                  <div class="ct_outline_bg h-100 ct_p_10">
                    <div class="d-flex align-items-start justify-content-between gap-2">
                      <div>
                        <p class="ct_fs_16 ct_sky_blue_text mb-2">Deep Dive</p>
                        <h4 class="ct_fs_24">
                          {coachingDashboardData?.deepdive_count || 0} booked
                        </h4>
                      </div>
                      <img src="../assets/img/dash_icon_4.png" alt="" />
                    </div>
                    <ul class="d-flex align-items-center gap-2 mt-1">
                      <li class="ct_fs_12 ct_sky_blue_text">
                        <svg
                          width="23"
                          height="24"
                          viewBox="0 0 23 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_1696_32114)">
                            <path
                              d="M7.03156 16.2038L15.3574 8.03125"
                              stroke="#219EBC"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M15.5339 14.3985L15.5952 7.79909L8.99583 7.73778"
                              stroke="#219EBC"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1696_32114">
                              <rect
                                width="16"
                                height="16"
                                fill="white"
                                transform="translate(11.418 0.6875) rotate(45.5323)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        65%
                      </li>
                      <li class="ct_text_op_2">|</li>
                      <li class="ct_grey_text ct_fs_12">
                        Lead lasting transformational change.
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6 mb-4">
                  <div class="ct_outline_bg h-100 ct_p_10">
                    <div class="d-flex align-items-start justify-content-between gap-2">
                      <div>
                        <p class="ct_fs_16 ct_orange_text mb-2">
                          Team Coaching
                        </p>
                        <h4 class="ct_fs_24">
                          {coachingDashboardData?.team_count || 0}
                        </h4>
                      </div>
                      <img src="../assets/img/dash_icon_2.png" alt="" />
                    </div>
                    <ul class="d-flex align-items-center gap-2 mt-1">
                      <li class="ct_fs_12 ct_sky_blue_text">
                        38%
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_1696_32145)">
                            <path
                              d="M5.73231 8.00261L15.8359 13.8359"
                              stroke="#8ECAE6"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M9.74891 15.7105L16.1237 14.0024L14.4156 7.6276"
                              stroke="#8ECAE6"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1696_32145">
                              <rect
                                width="16"
                                height="16"
                                fill="white"
                                transform="translate(21.8555 8.07031) rotate(120)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </li>
                      <li class="ct_text_op_2">|</li>
                      <li class="ct_grey_text ct_fs_12">
                        your hosted events score
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6 mb-4 mb-md-0">
                  <div class="ct_outline_bg h-100 ct_p_10">
                    <div class="d-flex align-items-start justify-content-between gap-2">
                      <div>
                        <p class="ct_fs_16 ct_yellow_text mb-2">Growth Pro</p>
                        <h4 class="ct_fs_24">
                          {coachingDashboardData?.growth_count || 0}
                        </h4>
                      </div>
                      <img src="../assets/img/dash_icon_3.png" alt="" />
                    </div>
                    <ul class="d-flex align-items-center gap-2 mt-1">
                      <li class="ct_fs_12 ct_orange_text">
                        24%
                        <svg
                          width="23"
                          height="24"
                          viewBox="0 0 23 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_1696_32114)">
                            <path
                              d="M7.03156 16.2038L15.3574 8.03125"
                              stroke="#FB8500"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                            <path
                              d="M15.5339 14.3985L15.5952 7.79909L8.99583 7.73778"
                              stroke="#FB8500"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </g>
                          <defs>
                            <clipPath id="clip0_1696_32114">
                              <rect
                                width="16"
                                height="16"
                                fill="white"
                                transform="translate(11.418 0.6875) rotate(45.5323)"
                              ></rect>
                            </clipPath>
                          </defs>
                        </svg>
                      </li>
                      <li class="ct_text_op_2">|</li>
                      <li class="ct_grey_text ct_fs_12">
                        Drive deeper development with structure.
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6 mb-4 mb-md-0">
                  <div class="ct_outline_bg h-100 ct_p_10">
                    <div class="d-flex align-items-start justify-content-between gap-2">
                      <div>
                        <p class="ct_fs_16 ct_darksky_blue_text mb-2">
                          Group Coaching
                        </p>
                        <h4 class="ct_fs_24">
                          {coachingDashboardData?.group_count || 0}
                        </h4>
                      </div>
                      <img src="../assets/img/dash_icon_5.png" alt="" />
                    </div>
                    <ul class="d-flex align-items-center gap-2 mt-1">
                      <li class="ct_fs_12 ct_sky_blue_text">
                        38%
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_1696_32145)">
                            <path
                              d="M5.73231 8.00261L15.8359 13.8359"
                              stroke="#8ECAE6"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M9.74891 15.7105L16.1237 14.0024L14.4156 7.6276"
                              stroke="#8ECAE6"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1696_32145">
                              <rect
                                width="16"
                                height="16"
                                fill="white"
                                transform="translate(21.8555 8.07031) rotate(120)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </li>
                      <li class="ct_text_op_2">|</li>
                      <li class="ct_grey_text ct_fs_12">
                        your hosted events score
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <ul
                class="nav nav-pills mb-3 ct_custom_tabs3"
                id="pills-tab"
                role="tablist"
              >
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link active"
                    id="pills-Active_Clients-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-Active_Clients"
                    type="button"
                    role="tab"
                    aria-controls="pills-Active_Clients"
                    aria-selected="true"
                  >
                    Active Clients
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="pills-All_clients-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-All_clients"
                    type="button"
                    role="tab"
                    aria-controls="pills-All_clients"
                    aria-selected="false"
                    tabindex="-1"
                  >
                    All clients
                  </button>
                </li>
              </ul>

              <div class="tab-content" id="pills-tabContent">
                <div
                  class="tab-pane fade active show"
                  id="pills-Active_Clients"
                  role="tabpanel"
                  aria-labelledby="pills-Active_Clients-tab"
                >
                  <div class="table-responsive ct_coaching_table">
                    <table class="table">
                      <tbody>
                        <tr>
                          <td>
                            <div class="ct_coaching_card">
                              <div class="d-flex align-items-center justify-content-between gap-3">
                                <div>
                                  <h5 class="ct_fs_16 ct_fw_600  mb-1">
                                    Nuray Aksoy
                                  </h5>
                                  <p class="mb-0 ct_grey_text">
                                    Product Manager
                                  </p>
                                </div>
                                <div class="d-flex align-items-center gap-2">
                                  <span
                                    class="ct_clarity_badge ct_orange_text"
                                    style={{ backgroundColor: "#fa85001a" }}
                                  >
                                    Discovery Call
                                  </span>
                                  <div class="ct_right_dropdown dropdown">
                                    <button
                                      id="dropdownMenuButton"
                                      class="px-0"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <ul
                                      class="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton1"
                                    >
                                      <li>
                                        <a class="dropdown-item" href="#">
                                          View Details
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_darksky_blue_text"
                                          href="javascript:void(0)"
                                        >
                                          Reschedule
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_yellow_text"
                                          href="javascript:void(0)"
                                        >
                                          Send Message
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_orange_text"
                                          href="javascript:void(0)"
                                        >
                                          Cancelled
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>

                              <div class="mt-4">
                                <button class="ct_yellow_btn ct_orange_bg ct_h_35">
                                  Add session{" "}
                                </button>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="ct_coaching_card">
                              <div class="d-flex align-items-center justify-content-between gap-3">
                                <div>
                                  <h5 class="ct_fs_16 ct_fw_600 mb-1">
                                    Nuray Aksoy
                                  </h5>
                                  <p class="mb-0 ct_grey_text">
                                    Product Manager
                                  </p>
                                </div>
                                <div class="d-flex align-items-center gap-2">
                                  <span
                                    class="ct_clarity_badge ct_darksky_blue_text"
                                    style={{ backgroundColor: "#8ecae633" }}
                                  >
                                    Clarity
                                  </span>
                                  <div class="ct_right_dropdown dropdown">
                                    <button
                                      id="dropdownMenuButton"
                                      class="px-0"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <ul
                                      class="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton1"
                                    >
                                      <li>
                                        <a class="dropdown-item" href="#">
                                          View Details
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_darksky_blue_text"
                                          href="javascript:void(0)"
                                        >
                                          Reschedule
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_yellow_text"
                                          href="javascript:void(0)"
                                        >
                                          Send Message
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_orange_text"
                                          href="javascript:void(0)"
                                        >
                                          Cancelled
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>

                              <div>
                                <div class="ct_coaching_card mt-3">
                                  <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div>
                                      <h5 class="ct_fs_16  mb-1">Clarity</h5>
                                      <p class="mb-0 ct_grey_text">Session 1</p>
                                    </div>
                                    <div class="">
                                      <p class="ct_fs_12 mb-1">Feb 2, 2026</p>
                                      <span
                                        class="ct_clarity_badge ct_yellow_text"
                                        style={{
                                          backgroundColor: "#ffb8051a",
                                          padding: "5px 20px",
                                        }}
                                      >
                                        Live
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="mt-4">
                                <button class="ct_yellow_btn ct_light_sky_bg_1 ct_h_35">
                                  Add session{" "}
                                </button>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="ct_coaching_card">
                              <div class="d-flex align-items-center justify-content-between gap-3">
                                <div>
                                  <h5 class="ct_fs_16 ct_fw_600 mb-1">
                                    John Adam
                                  </h5>
                                  <p class="mb-0 ct_grey_text">CEO, xxxx</p>
                                </div>
                                <div class="d-flex align-items-center gap-2">
                                  <span
                                    class="ct_clarity_badge ct_yellow_text"
                                    style={{ backgroundColor: "#ffb8051a" }}
                                  >
                                    Growth
                                  </span>
                                  <div class="ct_right_dropdown dropdown">
                                    <button
                                      id="dropdownMenuButton"
                                      class="px-0"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <ul
                                      class="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton1"
                                    >
                                      <li>
                                        <a class="dropdown-item" href="#">
                                          View Details
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_darksky_blue_text"
                                          href="javascript:void(0)"
                                        >
                                          Reschedule
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_yellow_text"
                                          href="javascript:void(0)"
                                        >
                                          Send Message
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_orange_text"
                                          href="javascript:void(0)"
                                        >
                                          Cancelled
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>

                              <div>
                                <div class="ct_coaching_card mt-3">
                                  <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div>
                                      <h5 class="ct_fs_16  mb-1">Growth</h5>
                                      <p class="mb-0 ct_grey_text">Session 1</p>
                                    </div>
                                    <div class="">
                                      <p class="ct_fs_12 mb-1">Feb 20, 2026</p>
                                      <span
                                        class="ct_clarity_badge ct_darksky_blue_text"
                                        style={{
                                          backgroundColor: "#8ecae680",
                                          padding: "5px 20px",
                                        }}
                                      >
                                        In person
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="ct_coaching_card mt-3">
                                  <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div>
                                      <h5 class="ct_fs_16  mb-1">Growth</h5>
                                      <p class="mb-0 ct_grey_text">Session 2</p>
                                    </div>
                                    <div class="">
                                      <p class="ct_fs_12 mb-1">Feb 20, 2026</p>
                                      <span
                                        class="ct_clarity_badge ct_darksky_blue_text"
                                        style={{
                                          backgroundColor: "#8ecae680",
                                          padding: "5px 20px",
                                        }}
                                      >
                                        In person
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="ct_coaching_card mt-3">
                                  <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div>
                                      <h5 class="ct_fs_16  mb-1">Growth</h5>
                                      <p class="mb-0 ct_grey_text">Session 3</p>
                                    </div>
                                    <div class="">
                                      <p class="ct_fs_12 mb-1">Mar 2, 2026</p>
                                      <span
                                        class="ct_clarity_badge ct_yellow_text"
                                        style={{
                                          backgroundColor: "#ffb8051a",
                                          padding: "5px 20px",
                                        }}
                                      >
                                        Live
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="mt-4">
                                <button class="ct_yellow_btn  ct_h_35">
                                  Add session{" "}
                                </button>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="ct_coaching_card">
                              <div class="d-flex align-items-center justify-content-between gap-3">
                                <div>
                                  <h5 class="ct_fs_16 ct_fw_600 mb-1">
                                    Nuray Aksoy
                                  </h5>
                                  <p class="mb-0 ct_grey_text">
                                    Product Manager
                                  </p>
                                </div>
                                <div class="d-flex align-items-center gap-2">
                                  <span
                                    class="ct_clarity_badge ct_darksky_blue_text"
                                    style={{ backgroundColor: "#219cba6b" }}
                                  >
                                    Deep dive
                                  </span>
                                  <div class="ct_right_dropdown dropdown">
                                    <button
                                      id="dropdownMenuButton"
                                      class="px-0"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <ul
                                      class="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton1"
                                    >
                                      <li>
                                        <a class="dropdown-item" href="#">
                                          View Details
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_darksky_blue_text"
                                          href="javascript:void(0)"
                                        >
                                          Reschedule
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_yellow_text"
                                          href="javascript:void(0)"
                                        >
                                          Send Message
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_orange_text"
                                          href="javascript:void(0)"
                                        >
                                          Cancelled
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>

                              <div>
                                <div class="ct_coaching_card mt-3">
                                  <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div>
                                      <h5 class="ct_fs_16   mb-1">Deep Dive</h5>
                                      <p class="mb-0 ct_grey_text">Session 1</p>
                                    </div>
                                    <div class="">
                                      <p class="ct_fs_12 mb-1">Feb 15, 2026</p>
                                      <span
                                        class="ct_clarity_badge ct_yellow_text"
                                        style={{
                                          backgroundColor: "#ffb8051a",
                                          padding: "5px 20px",
                                        }}
                                      >
                                        Live
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="ct_coaching_card mt-3">
                                  <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div>
                                      <h5 class="ct_fs_16  mb-1">Deep Dive</h5>
                                      <p class="mb-0 ct_grey_text">Session 2</p>
                                    </div>
                                    <div class="">
                                      <p class="ct_fs_12 mb-1">Feb 17, 2026</p>
                                      <span
                                        class="ct_clarity_badge ct_yellow_text"
                                        style={{
                                          backgroundColor: "#ffb8051a",
                                          padding: " 5px 20px",
                                        }}
                                      >
                                        Live
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="ct_coaching_card mt-3">
                                  <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div>
                                      <h5 class="ct_fs_16  mb-1">Deep Dive</h5>
                                      <p class="mb-0 ct_grey_text">Session 3</p>
                                    </div>
                                    <div class="">
                                      <p class="ct_fs_12 mb-1">Feb 22, 2026</p>
                                      <span
                                        class="ct_clarity_badge ct_yellow_text"
                                        style={{
                                          backgroundColor: "#ffb8051a",
                                          padding: "5px 20px",
                                        }}
                                      >
                                        Live
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="ct_coaching_card mt-3">
                                  <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div>
                                      <h5 class="ct_fs_16  mb-1">Deep Dive</h5>
                                      <p class="mb-0 ct_grey_text">Session 4</p>
                                    </div>
                                    <div class="">
                                      <p class="ct_fs_12 mb-1">Feb 22, 2026</p>
                                      <span
                                        class="ct_clarity_badge ct_yellow_text"
                                        style={{
                                          backgroundColor: "#ffb8051a",
                                          padding: "5px 20px",
                                        }}
                                      >
                                        Live
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="ct_coaching_card mt-3">
                                  <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div>
                                      <h5 class="ct_fs_16  mb-1">Deep Dive</h5>
                                      <p class="mb-0 ct_grey_text">Session 5</p>
                                    </div>
                                    <div class="">
                                      <p class="ct_fs_12 mb-1">Feb 22, 2026</p>
                                      <span
                                        class="ct_clarity_badge ct_yellow_text"
                                        style={{
                                          backgroundColor: "#ffb8051a",
                                          padding: "5px 20px",
                                        }}
                                      >
                                        Live
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="mt-4">
                                <button class="ct_yellow_btn ct_darksky_btn  ct_h_35">
                                  Add session{" "}
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="pills-All_clients"
                  role="tabpanel"
                  aria-labelledby="pills-All_clients-tab"
                >
                  <div class="table-responsive ct_coaching_table">
                    <table class="table">
                      <tbody>
                        <tr>
                          <td>
                            <div class="ct_coaching_card">
                              <div class="d-flex align-items-center justify-content-between gap-3">
                                <div>
                                  <h5 class="ct_fs_16 ct_fw_600  mb-1">
                                    Nuray Aksoy
                                  </h5>
                                  <p class="mb-0 ct_grey_text">
                                    Product Manager
                                  </p>
                                </div>
                                <div class="d-flex align-items-center gap-2">
                                  <span
                                    class="ct_clarity_badge ct_orange_text"
                                    style={{ backgroundColor: "#fa85001a" }}
                                  >
                                    Discovery Call
                                  </span>
                                  <div class="ct_right_dropdown dropdown">
                                    <button
                                      id="dropdownMenuButton"
                                      class="px-0"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <ul
                                      class="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton1"
                                    >
                                      <li>
                                        <a class="dropdown-item" href="#">
                                          View Details
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_darksky_blue_text"
                                          href="javascript:void(0)"
                                        >
                                          Reschedule
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_yellow_text"
                                          href="javascript:void(0)"
                                        >
                                          Send Message
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_orange_text"
                                          href="javascript:void(0)"
                                        >
                                          Cancelled
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>

                              <div class="mt-4">
                                <button class="ct_yellow_btn ct_orange_bg ct_h_35">
                                  Add session{" "}
                                </button>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="ct_coaching_card">
                              <div class="d-flex align-items-center justify-content-between gap-3">
                                <div>
                                  <h5 class="ct_fs_16 ct_fw_600 mb-1">
                                    Nuray Aksoy
                                  </h5>
                                  <p class="mb-0 ct_grey_text">
                                    Product Manager
                                  </p>
                                </div>
                                <div class="d-flex align-items-center gap-2">
                                  <span
                                    class="ct_clarity_badge ct_darksky_blue_text"
                                    style={{ backgroundColor: "#8ecae633" }}
                                  >
                                    Clarity
                                  </span>
                                  <div class="ct_right_dropdown dropdown">
                                    <button
                                      id="dropdownMenuButton"
                                      class="px-0"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <ul
                                      class="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton1"
                                    >
                                      <li>
                                        <a class="dropdown-item" href="#">
                                          View Details
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_darksky_blue_text"
                                          href="javascript:void(0)"
                                        >
                                          Reschedule
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_yellow_text"
                                          href="javascript:void(0)"
                                        >
                                          Send Message
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_orange_text"
                                          href="javascript:void(0)"
                                        >
                                          Cancelled
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>

                              <div>
                                <div class="ct_coaching_card mt-3">
                                  <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div>
                                      <h5 class="ct_fs_16  mb-1">Clarity</h5>
                                      <p class="mb-0 ct_grey_text">Session 1</p>
                                    </div>
                                    <div class="">
                                      <p class="ct_fs_12 mb-1">Feb 2, 2026</p>
                                      <span
                                        class="ct_clarity_badge ct_yellow_text"
                                        style={{
                                          backgroundColor: "#ffb8051a",
                                          padding: "5px 20px",
                                        }}
                                      >
                                        Live
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="mt-4">
                                <button class="ct_yellow_btn ct_light_sky_bg_1 ct_h_35">
                                  Add session{" "}
                                </button>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="ct_coaching_card">
                              <div class="d-flex align-items-center justify-content-between gap-3">
                                <div>
                                  <h5 class="ct_fs_16 ct_fw_600 mb-1">
                                    John Adam
                                  </h5>
                                  <p class="mb-0 ct_grey_text">CEO, xxxx</p>
                                </div>
                                <div class="d-flex align-items-center gap-2">
                                  <span
                                    class="ct_clarity_badge ct_yellow_text"
                                    style={{ backgroundColor: "#ffb8051a" }}
                                  >
                                    Growth
                                  </span>
                                  <div class="ct_right_dropdown dropdown">
                                    <button
                                      id="dropdownMenuButton"
                                      class="px-0"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <ul
                                      class="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton1"
                                    >
                                      <li>
                                        <a class="dropdown-item" href="#">
                                          View Details
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_darksky_blue_text"
                                          href="javascript:void(0)"
                                        >
                                          Reschedule
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_yellow_text"
                                          href="javascript:void(0)"
                                        >
                                          Send Message
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_orange_text"
                                          href="javascript:void(0)"
                                        >
                                          Cancelled
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>

                              <div>
                                <div class="ct_coaching_card mt-3">
                                  <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div>
                                      <h5 class="ct_fs_16  mb-1">Growth</h5>
                                      <p class="mb-0 ct_grey_text">Session 1</p>
                                    </div>
                                    <div class="">
                                      <p class="ct_fs_12 mb-1">Feb 20, 2026</p>
                                      <span
                                        class="ct_clarity_badge ct_darksky_blue_text"
                                        style={{
                                          backgroundColor: "#8ecae680",
                                          padding: "5px 20px",
                                        }}
                                      >
                                        In person
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="ct_coaching_card mt-3">
                                  <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div>
                                      <h5 class="ct_fs_16  mb-1">Growth</h5>
                                      <p class="mb-0 ct_grey_text">Session 2</p>
                                    </div>
                                    <div class="">
                                      <p class="ct_fs_12 mb-1">Feb 20, 2026</p>
                                      <span
                                        class="ct_clarity_badge ct_darksky_blue_text"
                                        style={{
                                          backgroundColor: "#8ecae680",
                                          padding: "5px 20px",
                                        }}
                                      >
                                        In person
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="ct_coaching_card mt-3">
                                  <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div>
                                      <h5 class="ct_fs_16  mb-1">Growth</h5>
                                      <p class="mb-0 ct_grey_text">Session 3</p>
                                    </div>
                                    <div class="">
                                      <p class="ct_fs_12 mb-1">Mar 2, 2026</p>
                                      <span
                                        class="ct_clarity_badge ct_yellow_text"
                                        style={{
                                          backgroundColor: "#ffb8051a",
                                          padding: "5px 20px",
                                        }}
                                      >
                                        Live
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="mt-4">
                                <button class="ct_yellow_btn  ct_h_35">
                                  Add session{" "}
                                </button>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="ct_coaching_card">
                              <div class="d-flex align-items-center justify-content-between gap-3">
                                <div>
                                  <h5 class="ct_fs_16 ct_fw_600 mb-1">
                                    Nuray Aksoy
                                  </h5>
                                  <p class="mb-0 ct_grey_text">
                                    Product Manager
                                  </p>
                                </div>
                                <div class="d-flex align-items-center gap-2">
                                  <span
                                    class="ct_clarity_badge ct_darksky_blue_text"
                                    style={{ backgroundColor: "#219cba6b" }}
                                  >
                                    Deep dive
                                  </span>
                                  <div class="ct_right_dropdown dropdown">
                                    <button
                                      id="dropdownMenuButton"
                                      class="px-0"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <ul
                                      class="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton1"
                                    >
                                      <li>
                                        <a class="dropdown-item" href="#">
                                          View Details
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_darksky_blue_text"
                                          href="javascript:void(0)"
                                        >
                                          Reschedule
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_yellow_text"
                                          href="javascript:void(0)"
                                        >
                                          Send Message
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item ct_orange_text"
                                          href="javascript:void(0)"
                                        >
                                          Cancelled
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>

                              <div>
                                <div class="ct_coaching_card mt-3">
                                  <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div>
                                      <h5 class="ct_fs_16   mb-1">Deep Dive</h5>
                                      <p class="mb-0 ct_grey_text">Session 1</p>
                                    </div>
                                    <div class="">
                                      <p class="ct_fs_12 mb-1">Feb 15, 2026</p>
                                      <span
                                        class="ct_clarity_badge ct_yellow_text"
                                        style={{
                                          backgroundColor: "#ffb8051a",
                                          padding: "5px 20px",
                                        }}
                                      >
                                        Live
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="ct_coaching_card mt-3">
                                  <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div>
                                      <h5 class="ct_fs_16  mb-1">Deep Dive</h5>
                                      <p class="mb-0 ct_grey_text">Session 2</p>
                                    </div>
                                    <div class="">
                                      <p class="ct_fs_12 mb-1">Feb 17, 2026</p>
                                      <span
                                        class="ct_clarity_badge ct_yellow_text"
                                        style={{
                                          backgroundColor: "#ffb8051a",
                                          padding: " 5px 20px",
                                        }}
                                      >
                                        Live
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="ct_coaching_card mt-3">
                                  <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div>
                                      <h5 class="ct_fs_16  mb-1">Deep Dive</h5>
                                      <p class="mb-0 ct_grey_text">Session 3</p>
                                    </div>
                                    <div class="">
                                      <p class="ct_fs_12 mb-1">Feb 22, 2026</p>
                                      <span
                                        class="ct_clarity_badge ct_yellow_text"
                                        style={{
                                          backgroundColor: "#ffb8051a",
                                          padding: "5px 20px",
                                        }}
                                      >
                                        Live
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="ct_coaching_card mt-3">
                                  <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div>
                                      <h5 class="ct_fs_16  mb-1">Deep Dive</h5>
                                      <p class="mb-0 ct_grey_text">Session 4</p>
                                    </div>
                                    <div class="">
                                      <p class="ct_fs_12 mb-1">Feb 22, 2026</p>
                                      <span
                                        class="ct_clarity_badge ct_yellow_text"
                                        style={{
                                          backgroundColor: "#ffb8051a",
                                          padding: "5px 20px",
                                        }}
                                      >
                                        Live
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="ct_coaching_card mt-3">
                                  <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div>
                                      <h5 class="ct_fs_16  mb-1">Deep Dive</h5>
                                      <p class="mb-0 ct_grey_text">Session 5</p>
                                    </div>
                                    <div class="">
                                      <p class="ct_fs_12 mb-1">Feb 22, 2026</p>
                                      <span
                                        class="ct_clarity_badge ct_yellow_text"
                                        style={{
                                          backgroundColor: "#ffb8051a",
                                          padding: "5px 20px",
                                        }}
                                      >
                                        Live
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="mt-4">
                                <button class="ct_yellow_btn ct_darksky_btn  ct_h_35">
                                  Add session{" "}
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CoachMenuLayout>
  );
};

export default CoachCoaching;
